import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=33cffd3a&scoped=true"
import script from "./Contact.vue?vue&type=script&setup=true&lang=js"
export * from "./Contact.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Contact.vue?vue&type=style&index=0&id=33cffd3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cffd3a",
  null
  
)

export default component.exports